import React from 'react';
import { IconTooltip } from 'utils/components/IconTooltip';

export default function VenueAnalysisHelp() {
    return (
        <IconTooltip>
            <div>
                This chart analyzes venue volumes and your order&apos;s
                liquidity sourcing. It informs what venues the symbol typically
                trades in, today&apos;s breakdown and your order&apos;s venue
                usage.
            </div>
            <div>
                The Market section provides the venue breakdown of the
                symbol&apos;s participation today and historically (averaged
                over the last 20 days).
            </div>
            <div>
                Your Order details and breakdown are available for easy
                comparison, and details on whether fills added or removed
                liquidity, were in the auction, or the result of a conditional.
            </div>
        </IconTooltip>
    );
}
